import outside from '../../../photos/komugiya_outside.jpg';

const newsPosts = [
    {
        title: "2021.5.31 新店舗オープン！",
        content: "近隣のご迷惑にならないよう、小麦屋の駐車場以外に車を停めないようお願いします。\n"
        + "コロナ感染のため、店内には一度に三組までご入店ください。\n"
        + "ごみの削除・地球温暖化防止のため、マイバッグのご持参のご協力をお願いします。\n",
        photo: outside,
    },
];
    
export default newsPosts;